import React, { Component } from 'react';
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';
import { connect } from 'react-redux';
import { Tooltip } from '../../shared/_tooltip';
import ScheduleSegment from '../_ScheduleSegment';
import { change, destroy, getFormValues, reduxForm } from 'redux-form/immutable';
import Button from '../../shared/form/_Button';
import {
  freeStandingAppointmentCreate,
  freeStandingAppointmentErrorClear
} from '../../../actions/freeStandingAppointmentAction';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import { TextArea } from '../../shared/_form';
import ItemSearch from '../../shared/search/ItemSearch';
import SearchedRepList from '../../shared/search/SearchedRepList';
import { searchBoxHide, searchBoxShow, searchRepClear } from '../../../actions/searchActions';
import { searchRep } from '../../../actions/searchActions';
import {
  APPOINTMENT_ALREADY_BOOKED_BY_REP,
  APPOINTMENT_OVERLAPPING,
  APPOINTMENT_TO_DATE_LESS_THAN_FROM, FREE_STANDING_APPOINTMENT_BLOCKED_REP_ERROR
} from '../../../constants/messages';

const FORM_NAME = 'freeStandingAppointment';

class FreeStandingAppointmentTooltip extends Component {
    static propTypes = {
      appointmentError:   PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
      clearError:         PropTypes.func.isRequired,
      clearForm:          PropTypes.func.isRequired,
      clearSearchRep:     PropTypes.func.isRequired,
      close:              PropTypes.func.isRequired,
      createFreeStandingAppointment: PropTypes.func.isRequired,
      currentUser:        PropTypes.instanceOf(Immutable.Map).isRequired,
      date:               PropTypes.instanceOf(Object).isRequired,
      form:               PropTypes.string.isRequired,
      formChange:         PropTypes.func.isRequired,
      formValues:         PropTypes.instanceOf(Immutable.Map),
      hideSearchBox:      PropTypes.func.isRequired,
      id:                 PropTypes.string.isRequired,
      loading:            PropTypes.bool,
      onClose:            PropTypes.func,
      rep:                PropTypes.instanceOf(Immutable.List),
      repSearch:          PropTypes.func.isRequired,
      show:               PropTypes.func.isRequired,
      showSearchBox:      PropTypes.func.isRequired
    };

    _handleShow = () => {
      const { id, show, formChange } = this.props;

      formChange('segment', 1);
      show(id);
    };

    _handleClose = () => {
      const { close, id, clearForm, clearSearchRep, clearError } = this.props;

      close(id);
      clearForm();
      clearSearchRep();
      clearError();
    };

    _handleSubmit = (e) => {
      e.preventDefault();
      const { createFreeStandingAppointment, date, currentUser, formValues, id } = this.props;

      if (!this._validate()) {
        return;
      }
      const params = {
        scheduled_on: date.format('YYYY-MM-DD'),
        from: formValues.get('from'),
        to: formValues.get('to'),
        office_id: currentUser.getIn(['data', 'office', 'id']),
        rep_id: formValues.getIn(['rep', 'id']),
        rep: formValues.get('rep'),
        segment_number: formValues.get('segment'),
        notes: formValues.get('notes'),
        tooltipId: id
      };

      createFreeStandingAppointment(params);
    };

    _handleDisable = () => {
      this._validate();
    };

    _validate = function() {
      const { formChange, formValues = Immutable.Map() } = this.props;
      const from    = formValues.get('from');
      const to      = formValues.get('to');

      if (!from || !to) {
        formChange('hasError', true);
        return false;
      }
      formChange('hasError', false);
      return true;
    };

    _freeStandingAppointmentErrors(type) {
      return {
        overlapping: APPOINTMENT_OVERLAPPING,
        from: APPOINTMENT_TO_DATE_LESS_THAN_FROM,
        repIsAlreadyBooked: APPOINTMENT_ALREADY_BOOKED_BY_REP,
        blocked: FREE_STANDING_APPOINTMENT_BLOCKED_REP_ERROR
      }[type];
    }

    _renderScheduleSegments() {
      const { formValues } = this.props;
      const hasError = formValues && formValues.get('hasError');
      const segmentValue = formValues && formValues.get('segment');

      const startTime = {
        '1':  25200,
        '2':  37800,
        '3':  46800

      };
      const endTime = {
        '1':  42400,
        '2':  50400,
        '3':  64800

      };

      return (<ScheduleSegment checkbox={ false }
        disabled={ false }
        endTime={ endTime[segmentValue] }
        form={ 'form' }
        fromValue={ 26100 }
        hasError={ hasError }
        label={ 'Time' }
        name={ 'freeStandingAppointment' }
        onDisable={ this._handleDisable }
        startTime={ startTime[segmentValue] }
        toValue={ 32400 } />);
    }

    _handleSelectChange = (event) => {
      const { formChange } = this.props;

      formChange('segment', event.target.value);
    };

    _renderSegmentSelect = () => {
      return (
        <select className={ 'form__field form__select' } onChange={ this._handleSelectChange }>
          <option key={ 1 } value={ 1 }>BREAKFAST</option>
          <option key={ 2 } value={ 2 }>LUNCH</option>
          <option key={ 3 } value={ 3 }>SNACK</option>
        </select>
      );
    };

    _handleRepClick = (item) => {
      const { formChange, hideSearchBox, clearError } = this.props;

      formChange('rep', item);
      this.clearRepSearch();
      clearError();
      hideSearchBox();
    };
    _handleSearchRep = (event) => {
      const { showSearchBox, hideSearchBox, formChange, repSearch } = this.props;
      const queryRep = event.target.value;

      formChange('query', queryRep);
      if (queryRep.length <= 2) {
        hideSearchBox();
        return false;
      }
      showSearchBox();
      return repSearch(queryRep);
    };

    _handleRepDelete = () => {
      const { formChange, clearError } = this.props;

      clearError();
      formChange('rep', Immutable.Map());
    };

    clearRepSearch = () => {
      const { formChange } = this.props;

      formChange('query', '');
    };

    componentWillUnmount() {
      const { clearForm } = this.props;

      clearForm();
    }

    render() {
      const { id, loading, appointmentError, formValues, rep } = this.props;
      const queryRep = formValues && formValues.get('query');
      const formRep = formValues && formValues.get('rep');

      return (
        <React.Fragment>
          <i aria-hidden='true' className='fa fa-calendar-plus-o free-standing-appointment__button' onClick={ this._handleShow } />
          <Tooltip className='manager__calendar-index__available-doctors-tooltip'
            header='Free standing appointment'
            id={ id }
            onClose={ this._handleClose }>
            <form onSubmit={ this._handleSubmit }>
              <Field component={ this._renderSegmentSelect } name='segment' />
              {this._renderScheduleSegments()}
              <div className='calendar__day__appointment-tooltip__body__row'>
                <div className='calendar__day__appointment-tooltip__body__label'>NOTES:</div>
                <Field className='calendar__day__appointment-tooltip__text-area' component={ TextArea } name={ 'notes' } />
              </div>
              <div className='calendar__day__appointment-tooltip__body__row'>
                <div className='calendar__day__appointment-tooltip__body__label'>Rep:</div>
                <ItemSearch className={ '.form__select' }
                  onHandleSearchItem={ this._handleSearchRep }
                  placeholder={ 'Search rep by name or product' }
                  queryItem={ queryRep }>
                  <SearchedRepList  onHandleItemClick={ this._handleRepClick }  searchedItems={ rep } />
                </ItemSearch>
                { formRep && formRep.size > 0 && <div className={ 'search__result' }>
                  <div>{`${formRep.get('name')} - ${formRep.get('company')}`}</div>
                  <i aria-hidden='true' className='fa fa-trash search__delete'  onClick={ this._handleRepDelete } />
                </div> }
              </div>
              {appointmentError && <div className={ 'free-standing-appointment--error' }>{this._freeStandingAppointmentErrors(Object.keys(appointmentError.response.body.details)[0])}</div>}
              <div className='form__submit form__submit--space-between'>
                <Button className='form__button form__button--purple' disabled={ loading } onClick={ this._handleClose } type='button'>Cancel</Button>
                <Button className='form__button form__button--green' loading={ loading } type='submit'>Save</Button>
              </div>
            </form>
          </Tooltip>
        </React.Fragment>

      );
    }
}

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(FORM_NAME)(state),
    rep: state.getIn(['search', 'data', 'items']) || Immutable.List()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    close: (id) => dispatch(tooltipHide({ id: id })),
    show: (id) => dispatch(tooltipShow({ id: id })),
    clearForm: () => dispatch(destroy(FORM_NAME)),
    clearError: () => dispatch(freeStandingAppointmentErrorClear()),
    showSearchBox: () => dispatch(searchBoxShow()),
    hideSearchBox: () => dispatch(searchBoxHide()),
    repSearch: (query) => dispatch(searchRep(query)),
    createFreeStandingAppointment: (params, rep) => dispatch(freeStandingAppointmentCreate(params, rep)),
    formChange: (param, value) => dispatch(change(FORM_NAME, param, value)),
    clearSearchRep: () => dispatch(searchRepClear())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm(
    { form: FORM_NAME,
      initialValues: {
        query: '',
        rep: Immutable.Map()
      }
    }
  )(FreeStandingAppointmentTooltip));



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_FreeStandingAppointmentTooltip.jsx